/**
 * The supoorted lanauage codes for the ads
 * If adding more you can find valid the codes here
 * https://github.com/libyal/libfwnt/wiki/Language-Code-identifiers
 */
export type LanguageCodes =
  | "be"
  | "be-fr"
  | "en-us"
  | "es-mx"
  | "es-es"
  | "es"
  | "de"
  | "de-at"
  | "de-de"
  | "de-li"
  | "de-lu"
  | "de-ch";

/** The supported sports for the ads */
export enum SportEnum {
  AMERICAN_FOOTBALL = "American Football",
  BASEBALL = "Baseball",
  BASKETBALL = "Basketball",
  BOXING = "Boxing",
  CHESS = "Chess",
  CRICKET = "Cricket",
  DARTS = "Darts",
  ENTERTAINMENT = "Entertainment",
  E_SPORTS = "E-Sports",
  FOOTBALL = "Football",
  FORMULA_1 = "Formula 1",
  GAELIC_FOOTBALL = "Gaelic Football",
  GENERIC_SPORT = "Generic Sport",
  GOLF = "Golf",
  GREYHOUND_RACING = "Greyhound Racing",
  HANDBALL = "Handball",
  HORSE_RACING = "Horse Racing",
  ICE_HOCKEY = "Ice Hockey",
  INDY_CAR = "IndyCar",
  MMA = "MMA",
  NASCAR = "Nascar",
  POLITICS = "Politics",
  RUGBY_LEAGUE = "Rugby League",
  RUGBY_UNION = "Rugby Union",
  SNOOKER = "Snooker",
  TABLE_TENNIS = "Table Tennis",
  TENNIS = "Tennis",
  VIRTUAL_FOOTBALL = "Virtual Football",
  VIRTUAL_GREYHOUND_RACING = "Virtual Greyhound Racing",
  VIRTUAL_HORSE_RACING = "Virtual Horse Racing"
}

/** The supported sports for the ads */
export type Sport =
  | SportEnum.AMERICAN_FOOTBALL
  | SportEnum.BASEBALL
  | SportEnum.BASKETBALL
  | SportEnum.BOXING
  | SportEnum.CHESS
  | SportEnum.CRICKET
  | SportEnum.DARTS
  | SportEnum.ENTERTAINMENT
  | SportEnum.E_SPORTS
  | SportEnum.FOOTBALL
  | SportEnum.FORMULA_1
  | SportEnum.GAELIC_FOOTBALL
  | SportEnum.GENERIC_SPORT
  | SportEnum.GOLF
  | SportEnum.GREYHOUND_RACING
  | SportEnum.HANDBALL
  | SportEnum.HORSE_RACING
  | SportEnum.ICE_HOCKEY
  | SportEnum.INDY_CAR
  | SportEnum.MMA
  | SportEnum.NASCAR
  | SportEnum.POLITICS
  | SportEnum.RUGBY_LEAGUE
  | SportEnum.RUGBY_UNION
  | SportEnum.SNOOKER
  | SportEnum.TABLE_TENNIS
  | SportEnum.TENNIS
  | SportEnum.VIRTUAL_FOOTBALL
  | SportEnum.VIRTUAL_GREYHOUND_RACING
  | SportEnum.VIRTUAL_HORSE_RACING;

export type SportsMap = Record<Sport, string>;

export type LanguageSportMap = Record<LanguageCodes, SportsMap>;

export interface Currencies {
  [key: string]: {
    territory: string;
    currency: string;
    symbol: string;
    code: string;
    fractionUnit: string;
    basicNumber: string;
    languageCode: string;
  };
}
